export const SMALL_MAX = 480;
export const MEDIUM_MIN = SMALL_MAX + 1;
export const MEDIUM_MAX = 960;
export const LARGE_MIN = MEDIUM_MAX + 1;
